import ConnectedIncubators from './ConnectedIncubators';

export default ConnectedIncubators;